import { ReactElement } from 'react';
import styles from './SpecialistInfo.module.scss';
import LogoMIPPngBlack from '../../../1_shared/assets/pictures/MIPVector.png';
import LogoMIPPngWhite from '../../../1_shared/assets/pictures/MIPVectorWhite.svg';

import { Typography } from '../../../1_shared/ui';
import { ISpecialisationInfoProps } from '../interfaces/ISpecialisationInfoProps';
import cn from 'classnames';
import { declination, yearTitles } from '../../../1_shared/helpers/declination';

const SpecialisationInfo = ({
  specialist,
  darkMode = false,
}: ISpecialisationInfoProps): ReactElement => {
  const { specialities, isMIPSpec, experience } = specialist;

  // NOTE: Содержит только перечень специализаций
  const specialitiesList = specialities.map((specialityItem, index) => (
    <span className={styles.element} key={`${specialityItem}-item`}>
      {specialityItem}
    </span>
  ));

  // NOTE: Отвечает за отображение признака "Преподаватель МИП"
  const mipMarker = isMIPSpec && (
    <div className={styles.mipMarker}>
      <img
        src={darkMode ? LogoMIPPngWhite : LogoMIPPngBlack}
        alt="DoTherapy"
        className={styles.MIPLogo}
      />
      Преподаватель МИП •{' '}
    </div>
  );

  // NOTE: Отвечает за отображение инф. "Опыт"
  const experienceInfo =
    experience &&
    ` • Опыт ${experience} ${declination(parseInt(experience), yearTitles)}`;

  return (
    <Typography
      className={cn(styles.container, {
        [styles.darkModeStyles]: darkMode,
      })}
    >
      {mipMarker}
      {specialitiesList}
      {experienceInfo}
    </Typography>
  );
};

export default SpecialisationInfo;
